// src/components/store/sections/faqs/FaqV68OrigamifaqOceanCyan.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV68OrigamifaqOceanCyan(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={68}
      archKey="origami_faq"
      archLabel="Origami Ribbon Panels"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
